import BracketOracleDefinition from "./BracketOracle.abi.json";
import ERC20Definition from "./ERC20.abi.json";
import EscrowDefintion from "./Escrow.abi.json";
import PricingDefinition from "./Pricing.abi.json";
import UniswapQuoterV3Definition from "./UniswapQuoterV3.abi.json";
import UniswapV3FactoryDefinition from "./UniswapV3Factory.abi.json";


export const BracketOracle = BracketOracleDefinition;
export const ERC20 = ERC20Definition;
export const Escrow = EscrowDefintion;
export const Pricing = PricingDefinition;
export const UniswapQuoterV3 = UniswapQuoterV3Definition;
export const UniswapV3Factory = UniswapV3FactoryDefinition;
